import * as React from 'react';
import { sortBasedOnList } from '../utils';

export type Table13aData = { [key: string]: Table13aRow };

export interface ITable13aProps {
  data: Table13aData;
}

interface ITable13aState {
}

export interface Table13aRow {
  fatal: number;
  injuryA: number;
  injuryB: number;
  injuryC: number;
  pdo: number;
  total: number;
}

const sortOrder = [
  "Automobile",
  "Van",
  "Utility Vehicle",
  "Pickup Truck",
  "Motorcycle",
  "ATV/ROV",
  "Other",
  "Unknown",
  "Not Stated",
];

export default class Table13a extends React.Component<ITable13aProps, ITable13aState> {
  constructor(props: ITable13aProps) {
    super(props);
  }

  componentDidMount = function () {
  }

  public render() {
    return (
      this.props.data ?
        <table className="ss-table summaryTable1">
          <colgroup>
            <col style={{ width: '50%' }} />
            <col span={6} style={{ width: '8.3%' }} />
          </colgroup>
          <thead>
            <tr>
              <th rowSpan={2} className="border-right-bold">
                <div className="ss-table-header" style={{ height: 64 }}>
                  <span className="header-number" style={{ border: 'none' }}>13a</span>
                  <div style={{ width: '3px', height: '64px', backgroundColor: 'black' }} />
                  <span className="header-text">BODY STYLE OF CRASH VEHICLES</span>
                </div>
              </th>
              <th rowSpan={2}>TOTAL</th>
              <th rowSpan={2}>FATAL</th>
              <th colSpan={3}>INJURY</th>
              <th rowSpan={2}>PDO **</th>
            </tr>
            <tr>
              <th>A*</th>
              <th>B*</th>
              <th>C*</th>
            </tr>
          </thead>
          <tbody>
            {sortBasedOnList(this.props.data, sortOrder).map((key) =>
              <tr key={key}>
                <td className="border-right-bold">{key}</td>
                <td className="numberTotals">{this.props.data[key].total}</td>
                <td className="numberTotals">{this.props.data[key].fatal}</td>
                <td className="numberTotals">{this.props.data[key].injuryA}</td>
                <td className="numberTotals">{this.props.data[key].injuryB}</td>
                <td className="numberTotals">{this.props.data[key].injuryC}</td>
                <td className="numberTotals">{this.props.data[key].pdo}</td>
              </tr>
            )}
          </tbody>
        </table>
        : <p>Loading...</p>
    );
  }
}
